export const ApplicantStage = {
  PanVerification: 1,
  AddressDetails: 2,
  EmploymentDetails: 3,
  BankStatement: 4,
  AwaitingApproval: 5,
  CoapplicantRequired: 6,
  AwaitingCoapplicantConsent: 7,
  Approved: 8,
  SanctionTermsAccepted: 9,
  Digilocker: 10,
  Selfie: 11,
  Agreement: 12,
  BankAccountVerified: 13,
  Mandate: 14,
  PFCollections: 15,
  ProcessComplete: 16,
  Disbursed: 17,
  Rejected: 18,
  BAVPage: 19,
  LoanOffer: 20,
  ExperianValidation: 21,
  ExperianAutoApproved: 22,
  ExperianManualApproved: 23,
  BsDone: 24,
  FundSourceAssigned: 25,
} as const;

export const ChannelId = {
  B2B: 1,
  Paylater: 2,
  Zensure: 3,
  CustomerPortal: 4,
  InsurFin: 5,
  QEC: 6,
  APP_Android: 7,
  ChannelDashboard: 8,
  APP_IOS: 9,
  Dashboard: 10,
  PartnerPage: 11,
  MyClassBoard: 12,
} as const;

export const BankStatementMethod = {
  AA: "aa",
  PDF: "pdf",
} as const;
